var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_8760",
    "data-name": "Group 8760",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 66.904,
    height: 59.731,
    viewBox: "0 0 66.904 59.731",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_69",
    "data-name": "Rectangle 69",
    width: 66.904,
    height: 59.731,
    fill: "#2c2b34"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M65.939,21.971,38.63,1.723a8.641,8.641,0,0,0-10.356,0L.968,21.971a2.388,2.388,0,1,0,2.843,3.837l3.36-2.487V52.5a7.239,7.239,0,0,0,7.23,7.233H26.284a2.389,2.389,0,1,0,0-4.779H14.4A2.454,2.454,0,0,1,11.95,52.5V19.777L31.12,5.56a3.846,3.846,0,0,1,4.664,0L54.957,19.777V52.5A2.455,2.455,0,0,1,52.5,54.952H38.962a10.93,10.93,0,0,1-3.443-3.589,10.1,10.1,0,0,1-.934-2.177,15.282,15.282,0,0,0,8.2-7.558A15.506,15.506,0,0,0,40,24.676a2.4,2.4,0,0,0-1.823-.786A14.713,14.713,0,0,0,23.942,35.366a14.557,14.557,0,0,0,5.682,14.325c.048.036.108.05.158.084a15.158,15.158,0,0,0,1.6,3.99A16.073,16.073,0,0,0,37,59.389c.067.038.136.055.2.086a1.82,1.82,0,0,0,.208.091,2.422,2.422,0,0,0,.822.165H52.5A7.241,7.241,0,0,0,59.736,52.5V23.321l3.355,2.487a2.389,2.389,0,1,0,2.848-3.837M28.628,36.307a9.821,9.821,0,0,1,8.545-7.558A10.636,10.636,0,0,1,38.456,39.6a10.014,10.014,0,0,1-4.234,4.475A16.491,16.491,0,0,1,35.6,39.273a2.388,2.388,0,1,0-4.294-2.093A21.048,21.048,0,0,0,29.622,42.5a9.273,9.273,0,0,1-.994-6.191",
    transform: "translate(0 -0.001)",
    fill: "#2c2b34"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTHouse);
export default __webpack_public_path__ + "static/media/t_house.e5e589c79228018db28f23cb727928ed.svg";
export { ForwardRef as ReactComponent };